export const UNDEFINED_LABEL = 'n.c.';
